const isEqual = (x, y) => {
	if (x === null || y === null || x === undefined || y === undefined)return false;
	if (typeof x !== 'object')return false;
	if (typeof y !== 'object')return false;
	if (Object.keys(x).length !== Object.keys(y).length)return false;
	for (let key in x) {
		if (!x.hasOwnProperty(key))continue;
		if (x[key] !== y[key])return false;
	}
	return true;
}

export default isEqual;